import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { mget, mpatch, errMsg, fmtDate, fmtDay } from "@/manager/lib";
import { PageHeader, Card, Empty } from "@/manager/ui";

const STATUS = { pendiente: "bg-amber-100 text-amber-800", programada: "bg-sky-100 text-sky-800", hecha: "bg-emerald-100 text-emerald-800" };

export default function Cleaning() {
  const navigate = useNavigate();
  const [jobs, setJobs] = useState([]);
  const load = useCallback(() => mget("/cleaning").then(setJobs), []);
  useEffect(() => { load(); }, [load]);
  const patch = async (j, body) => { try { await mpatch(`/cleaning/${j.id}`, body); load(); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <div data-testid="manager-cleaning">
      <PageHeader eyebrow="Limpieza" title="Limpiezas de la sala" />
      <p className="text-sm text-[#6b6a66] mb-4">Se crea una limpieza automática después de cada evento en la sala (no en eventos externos). Al programarla o marcarla como hecha, se completa la tarea del evento.</p>
      <div className="space-y-3">
        {jobs.map((j) => (
          <Card key={j.id} className="p-4 flex flex-wrap items-center gap-3" data-testid={`clean-row-${j.id}`}>
            <div className="flex-1 min-w-[220px]">
              <button onClick={() => navigate(`/manager/eventos/${j.event_id}`)} className="font-medium text-sm hover:underline text-left">Después de: {j.event_title}</button>
              <p className="text-xs text-[#6b6a66]">Evento termina {fmtDate(j.date)} {j.event_end}</p>
              {j.next_event && <p className="text-xs text-[#9a7f3f] mt-0.5">Antes de: {j.next_event.title} · {fmtDay(j.next_event.date)} {j.next_event.start_time}</p>}
            </div>
            <Input type="date" className="w-40 h-9" defaultValue={j.date} onBlur={(e) => e.target.value !== j.date && patch(j, { date: e.target.value })} data-testid={`clean-date-${j.id}`} />
            <Input type="time" className="w-28 h-9" defaultValue={j.time} onBlur={(e) => e.target.value !== j.time && patch(j, { time: e.target.value })} data-testid={`clean-time-${j.id}`} />
            <Input placeholder="Responsable" className="w-40 h-9" defaultValue={j.assignee} onBlur={(e) => e.target.value !== j.assignee && patch(j, { assignee: e.target.value })} data-testid={`clean-assignee-${j.id}`} />
            <Select value={j.status} onValueChange={(v) => patch(j, { status: v })}>
              <SelectTrigger className={`w-36 h-9 ${STATUS[j.status]}`} data-testid={`clean-status-${j.id}`}><SelectValue /></SelectTrigger>
              <SelectContent><SelectItem value="pendiente">Pendiente</SelectItem><SelectItem value="programada">Programada</SelectItem><SelectItem value="hecha">Hecha</SelectItem></SelectContent>
            </Select>
          </Card>
        ))}
        {!jobs.length && <Card><Empty>No hay limpiezas. Aparecerán al crear eventos en la sala.</Empty></Card>}
      </div>
    </div>
  );
}
